(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/components/betslip.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/components/betslip.js');

'use strict';

const {
  useEffect,
  useState,
  useRef,
  useCallback
} = React;
const {
  locationConfirmedAtom,
  pinLocationAtom,
  shouldShowPinAtom
} = svs.lyckoplatsen.components.page_play.jotai.atoms;
const {
  useAtom,
  useSetAtom,
  useAtomValue
} = jotai;
const {
  BetslipConfirm,
  BetslipDetails
} = svs.lyckoplatsen.components.page_play.react.components;
const {
  isSelfService
} = svs.core.config.data.svsconfig;
const Betslip = () => {
  const [height, setHeight] = useState('0px');
  const refBetslipBody = useRef(null);
  const setPinLocation = useSetAtom(pinLocationAtom);
  const [locationConfirmed, setLocationConfirmed] = useAtom(locationConfirmedAtom);
  const shouldShowPin = useAtomValue(shouldShowPinAtom);
  const updateHeight = useCallback(() => {
    if (!shouldShowPin) {
      setHeight("0px");
    } else if (refBetslipBody.current) {
      const newHeight = "".concat(refBetslipBody.current.scrollHeight, "px");
      if (height !== newHeight) {
        setHeight(newHeight);
      }
    }
  }, [shouldShowPin, height]);
  useEffect(() => {
    updateHeight();
  }, [shouldShowPin, updateHeight]);
  useEffect(() => {
    const observer = new ResizeObserver(() => {
      requestAnimationFrame(() => {
        updateHeight();
      });
    });
    if (refBetslipBody.current) {
      observer.observe(refBetslipBody.current);
    }
    return () => {
      if (refBetslipBody.current) {
        observer.unobserve(refBetslipBody.current);
      }
    };
  }, [updateHeight]);
  const handleDimmerClick = () => {
    setPinLocation({
      lat: null,
      lng: null
    });
    setLocationConfirmed(false);
  };
  useEffect(() => {
    if (isSelfService && svs.components.selfserviceCart && svs.components.selfserviceCart.getCartInstance) {
      var _svs$components$selfs;
      (_svs$components$selfs = svs.components.selfserviceCart) === null || _svs$components$selfs === void 0 || (_svs$components$selfs = _svs$components$selfs.getCartInstance()) === null || _svs$components$selfs === void 0 || _svs$components$selfs.setGameCallback(() => {
        if (!locationConfirmed && shouldShowPin) {
          return svs.components.selfserviceCart.constants.GAMECALLBACK_HASCOMPLETEGAME;
        }
        return svs.components.selfserviceCart.constants.GAMECALLBACK_NOGAME;
      });
    }
  }, [locationConfirmed, shouldShowPin]);
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "lp-play-betslip-dimmer ".concat(locationConfirmed ? 'lp-play-betslip-dimmer-show' : ''),
    onClick: handleDimmerClick
  }), React.createElement("div", {
    className: "lp-play-betslip \n          ".concat(shouldShowPin ? 'betslip-show-shadow' : 'betslip-hide-shadow'),
    style: {
      height: shouldShowPin ? height : 0
    }
  }, React.createElement("div", {
    className: "lp-betslip-body",
    ref: refBetslipBody
  }, !locationConfirmed && shouldShowPin && React.createElement(BetslipConfirm, null), locationConfirmed && React.createElement(BetslipDetails, null))));
};
setGlobal('svs.lyckoplatsen.components.page_play.react.components', {
  Betslip
});

 })(window);